import styled from '@emotion/styled'
import { colors, typography, TextField } from '@resiliatech/birdsong'

export const StyledTextField = styled(TextField)`
  .MuiInputBase-input {
    ${typography.baseline.regularSans};
  }
  .MuiInputBase-input::placeholder {
    color: #68737b;
  }
`

export const Description = styled.p`
  ${typography.baseline.regularSans};
  color: ${colors.copy.paragraphDark};
`
